import React, { useState } from 'react';

function CodePlayground({ initialCode = '' }) {
    const [code, setCode] = useState(initialCode);

    const handleCodeChange = (e) => {
        setCode(e.target.value);
    };

    return (
        <div className="code-playground-container">
            <div className="editor-pane">
                <div className="pane-header">Code Editor</div>
                <textarea
                    className="code-editor"
                    value={code}
                    onChange={handleCodeChange}
                    spellCheck="false"
                />
            </div>
            <div className="preview-pane">
                <div className="pane-header">Live Preview</div>
                <iframe
                    title="Live Preview"
                    srcDoc={code}
                    className="preview-frame"
                    sandbox="allow-scripts"
                />
            </div>
        </div>
    );
}

export default CodePlayground;
